// extracted by mini-css-extract-plugin
export default {"image":"CharacterGeneratorHeader_image__si5HX"};